import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Button from '../../../elements/Button'
import styles from './styles.module.scss'
import DateSearch from '../../../elements/DateSearch'
import { useState, useEffect } from 'react'
import { withModifiers } from '../../../helpers/withModifiers'
import axios from '/components/configs/axios'
import { useRouter } from 'next/router'

const Welcome = ({
  totalProperties,
  translations,
  shadowRef,
  contentTranslations
}) => {
  const router = useRouter()
  const [isActive, setIsActive] = useState(false)
  const [maxPrice, setMaxPrice] = useState(false)

  useEffect(() => {
    axios.get('real-estate/properties/max-price').then((res) => {
      setMaxPrice(res.data / 1000)
    })
  }, [router.locale])

  return (
    <Section variant={['center']}>
      <Container>
        <div className={styles.intro}>
          <h1 className={styles.intro__title}>
            {contentTranslations.title[router.locale]}
          </h1>

          <div className={styles.intro__subtitle}>
            {contentTranslations.description[router.locale]}
          </div>

          <div className={styles.intro__wrapper}>
            <div
              className={withModifiers(
                'intro__card',
                [isActive && 'is-active'],
                styles
              )}
            >
              {maxPrice && (
                <DateSearch
                  translations={translations}
                  setIsActive={setIsActive}
                  isActive={isActive}
                  shadowRef={shadowRef}
                  optional
                  price={maxPrice}
                  target="real-estate"
                  form={[
                    'location',
                    'homeType',
                    'priceRange',
                    'bedrooms',
                    'listings'
                  ]}
                />
              )}
            </div>
          </div>

          <Button href="/real-estate/search" variant={['label']}>
            {`${contentTranslations.see[router.locale]} ${totalProperties} ${
              contentTranslations.properties[router.locale]
            }`}
          </Button>
        </div>
      </Container>
    </Section>
  )
}

export default Welcome
